import { render, staticRenderFns } from "./PositionsOrganic.vue?vue&type=template&id=dca58d26&"
import script from "./PositionsOrganic.vue?vue&type=script&lang=js&"
export * from "./PositionsOrganic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports